import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { subscribeToNewsletter, unsubscribeFromNewsletter } from '../api/newsletterApi';

export const useNewsletterSubscription = () => {
  const mutation = useMutation(subscribeToNewsletter, {
    onSuccess: () => {
      toast.success('Successfully subscribed to newsletter!');
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || 'Failed to subscribe';
      toast.error(errorMessage);
    }
  });

  return mutation;
};

export const useNewsletterUnsubscribe = () => {
  const mutation = useMutation(unsubscribeFromNewsletter, {
    onSuccess: () => {
      toast.success('Successfully unsubscribed from newsletter');
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || 'Failed to unsubscribe';
      toast.error(errorMessage);
    }
  });

  return mutation;
};
